import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { rules } from "../../../siteData/rules";
import { useContext, useEffect, useRef, useState } from "react";
import { Progress, Upload } from "antd";
import PopComponent from "../../popContent";
import CustomModal from "../../../hoc/CustomModal";
import icon_plus_white from "../../../assets/images/icon_plus_white.svg";
import { ContextState } from "../../../layout";

const AddSkillPop = ({ btnLoader, loading, handleAddCategory, handleChange, categoryData, incomplete_logo, complete_logo, handleModalClose, setFormRef }) => {
    const [error, setError] = useState({});
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);
    const [form] = Form.useForm();
    form.setFieldsValue(categoryData);
    const uploadList1 = useRef(null);
    const uploadList2 = useRef(null);
    const { contextReducer } = useContext(ContextState);

    useEffect(() => {
        setFormRef(form);
    }, []);

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    const handleUpload = (file) => {
        if (!file.type.match(/png|jpeg|jpg/g)) {
            handleOpenModal('ErrorPop', { header: "Info", body: 'Please add only png, jpg or jpeg files' })
            return Upload.LIST_IGNORE;
        }
    };

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => handleAddCategory(e, form)}
                scrollToFirstError
                className="attached_courses-add_skill"
            >
                <h2>{contextReducer.cms_type === 'skill-up' ? 'add skill' : 'add skill name'}</h2>
                <Form.Item label="Skill Name" name="name" rules={rules.categoryName} className="form_group">
                    {/* <label htmlFor="">Skill Name</label> */}
                    <input autoComplete={"off"} onChange={handleChange} value={categoryData.name} name="name" type="text" className="form_control" autoFocus />
                </Form.Item>
                {contextReducer.cms_type === 'skill-up' &&
                    <>
                        <label htmlFor="">Skill Badges</label>
                        <div className="badges">
                            <div className="badge_pic">
                                <Upload ref={uploadList1} accept={"image/*"} customRequest={(e) => handleChange({ file: e, type: "file", name: "incomplete_logo" })} beforeUpload={handleUpload} showUploadList={false} className={`bio_file_upload file_upload ${loading ? 'disabled' : ''}`}>
                                    <div className="file_upload_button">
                                        {!incomplete_logo &&
                                            <span>
                                                {
                                                    uploadList1?.current?.fileList?.[uploadList1.current.fileList?.length - 1]?.percent !== undefined &&
                                                        uploadList1?.current?.fileList?.[uploadList1.current.fileList?.length - 1]?.percent !== 100 ?
                                                        <Progress width={50} showInfo={false} type="circle" percent={uploadList1?.current?.fileList?.[uploadList1.current.fileList?.length - 1]?.percent} /> :
                                                        <img src={icon_plus_white} alt="" />
                                                }
                                            </span>
                                        }
                                        {incomplete_logo && (
                                            uploadList1?.current?.fileList?.[uploadList1.current.fileList?.length - 1]?.percent !== undefined &&
                                                uploadList1?.current?.fileList?.[uploadList1.current.fileList?.length - 1]?.percent !== 100 ?
                                                <div className="sample_video_thumb">
                                                    <span className="uploaded_thumb_img">
                                                        <Progress width={50} showInfo={false} type="circle" percent={uploadList1?.current?.fileList?.[uploadList1.current.fileList?.length - 1]?.percent} />
                                                    </span>
                                                </div> :
                                                <div className="sample_video_thumb">
                                                    <span className="uploaded_thumb_img  cursor_pointer">
                                                        <img src={incomplete_logo} alt="Video thumb" className="img_fluid img_object_center radius_5" height="85" width="110" />
                                                    </span>
                                                </div>
                                        )
                                        }
                                    </div>
                                </Upload>
                                <label htmlFor="">Incomplete Badge</label>
                            </div>
                            <div className="badge_pic">
                                <Upload ref={uploadList2} accept={"image/*"} customRequest={(e) => handleChange({ file: e, type: "file", name: "complete_logo" })} beforeUpload={handleUpload} showUploadList={false} className={`bio_file_upload file_upload ${loading ? 'disabled' : ''}`}>
                                    <div className="file_upload_button">
                                        {!complete_logo &&
                                            <span>
                                                {
                                                    uploadList2?.current?.fileList?.[uploadList2.current.fileList?.length - 1]?.percent !== undefined &&
                                                        uploadList2?.current?.fileList?.[uploadList2.current.fileList?.length - 1]?.percent !== 100 ?
                                                        <Progress width={50} showInfo={false} type="circle" percent={uploadList2?.current?.fileList?.[uploadList2.current.fileList?.length - 1]?.percent} /> :
                                                        <img src={icon_plus_white} alt="" />
                                                }
                                            </span>
                                        }
                                        {complete_logo && (
                                            uploadList2?.current?.fileList?.[uploadList2.current.fileList?.length - 1]?.percent !== undefined &&
                                                uploadList2?.current?.fileList?.[uploadList2.current.fileList?.length - 1]?.percent !== 100 ?
                                                <div className="sample_video_thumb">
                                                    <span className="uploaded_thumb_img">
                                                        <Progress width={50} showInfo={false} type="circle" percent={uploadList2?.current?.fileList?.[uploadList2.current.fileList?.length - 1]?.percent} />
                                                    </span>
                                                </div> :
                                                <div className="sample_video_thumb">
                                                    <span className="uploaded_thumb_img  cursor_pointer">
                                                        <img src={complete_logo} alt="Video thumb" className="img_fluid img_object_center radius_5" height="85" width="110" />
                                                    </span>
                                                </div>
                                        )
                                        }
                                    </div>
                                </Upload>
                                <label htmlFor="">Complete Badge</label>
                            </div>
                        </div>
                    </>
                }
                <div className="form_group form_footer">
                    <FilledButton onClick={() => handleModalClose()} type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" loading={btnLoader} className={`btn btn_primary ${loading ? 'disabled' : ''}`} id='btn_loader_primary' value="submit" />
                </div>
            </Form>
            {
                Modal && (
                    <CustomModal className='errorPop modal skill_model' handleOpen={handleOpenModal} open={openModal}>
                        <Modal
                            error={error}
                            handleOpenModal={handleOpenModal}
                        />
                    </CustomModal>
                )
            }
        </div>
    )
};

export default AddSkillPop;